<header eos-header></header>
<eos-loader></eos-loader>
<div class="container-fluid mt-70">
  <div *ngIf="isDelegateSet" class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Delegate set!</strong> Actions are currently being delegated. Go to settings to undo delegation.
        <button type="button" (click)="closeDelegateWarning()" class="btn-close" aria-label="Close"></button>
  </div>
  <div *ngIf="isPendingComment" class="alert alert-warning alert-dismissible fade show" role="alert">
    You must update the <strong>comments</strong> for the below profiles in order to proceed.
</div>
  <div *ngIf="isPendingStartdates" class="alert alert-warning alert-dismissible fade show" role="alert">
    Please amend the <strong>Start date</strong> of the below profiles to a future date in order to proceed.
  </div>
  <div *ngIf="isPendingImmAutoVisaRequestProfiles" class="alert alert-warning alert-dismissible fade show" role="alert">
   <strong>Please confirm if you would like to submit a visa issuance request for each of the requests listed below by clicking on the edit button. You will not be able to view your previous requests or create new requests until this is confirmed.</strong> 
  </div>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" [ngClass]="{'active': item.isActive}" *ngFor="let item of menuList">
        <a [routerLink]="[item.url]">{{item.label}}</a>
      </li>
      <li *ngIf="isProfileUpdate()" style="margin-left: auto; cursor: pointer;color:black">
        <div class="dropdown" ngbDropdown display="dynamic" placement="bottom-right">
          <div ngbDropdownToggle>
            <img src="design/images/play_arrow.svg" style="width: 28px" />
            <span class="videoLink">For guidance on how to update your TMT profile,please click here</span>
          </div>
          <div class="dropdown-menu" style="text-align: center" ngbDropdownMenu>
            <!-- <img src="design/images/upload_ur_docs.png" style="width: 370px" (click)="openVideoTab(this.uploadYorDocurl)" />
            <img src="design/images/upload_dep_details.png" style="width: 370px; padding-top: 5px" (click)="openVideoTab(this.uploadDepDocurl)" /> -->

            <img src="design/images/update_personal_info.png" style="width: 370px" (click)="openVideoTab('assets/video/update_personal_info.mp4')"/>
            <img src="design/images/upload_dep_details.png" style="width: 370px; padding-top: 5px" (click)="openVideoTab('assets/video/update_dependent_info.mp4')" />
           <img src="design/images/upload_ur_docs.png" style="width: 370px; padding-top: 5px" (click)="openVideoTab('assets/video/upload_document.mp4')"/>
            <img src="design/images/raise_ticket.png" style="width: 370px; padding-top: 5px" (click)="openVideoTab('assets/video/raise_supportTicket.mp4')" />

          </div>
        </div>
      </li>
    </ol> 
  </nav>

  <div [ngClass]="shouldDarkBg() ? 'brd-grey' : 'bg-white'">
    <router-outlet *ngIf="!isIframe"></router-outlet>
    <eos-toast></eos-toast>
  </div>
  <footer eos-footer></footer>
</div>
